import { render, staticRenderFns } from "./RemarkModal.vue?vue&type=template&id=3dba06fa&scoped=true"
import script from "./RemarkModal.vue?vue&type=script&lang=js"
export * from "./RemarkModal.vue?vue&type=script&lang=js"
import style0 from "./RemarkModal.vue?vue&type=style&index=0&id=3dba06fa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dba06fa",
  null
  
)

export default component.exports